(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(hover: hover) and (pointer: fine)');
  var initTimer;
  var LOADER_TIMEOUT_MS = 5000;

  function isImageReady(img) {
    if (!img) return true;
    if (img.classList.contains('lazyloaded') || img.classList.contains('ls-is-cached')) return true;
    if (img.complete) return true;
    return false;
  }

  function getCardLoaderImages(card) {
    var images = [];
    var seen = new Set();

    function addImage(img) {
      if (!img || seen.has(img)) return;
      seen.add(img);
      images.push(img);
    }

    card.querySelectorAll('[data-product-card-featured-image]').forEach(addImage);
    card.querySelectorAll('.pc-gallery__slide:first-child .pc-gallery__img').forEach(addImage);

    if (!images.length) {
      card.querySelectorAll('.product-card__img--visible, .pc-gallery__img').forEach(addImage);
    }

    return images;
  }

  function hideProductCardLoader(card) {
    var loader = card.querySelector('[data-product-card-preloader]');
    if (!loader || loader.classList.contains('hidden')) return;
    loader.classList.add('hidden');
    card.classList.add('is-pc-images-ready');
  }

  function dismissProductCardLoader(card) {
    if (!card || card.dataset.pcLoaderDismissed === 'true') return;

    var loader = card.querySelector('[data-product-card-preloader]');
    if (!loader) return;

    var images = getCardLoaderImages(card);
    var pending = 0;

    function checkReady() {
      var allReady = images.every(isImageReady);
      if (allReady || !images.length) {
        card.dataset.pcLoaderDismissed = 'true';
        hideProductCardLoader(card);
      }
    }

    function watchImage(img) {
      if (isImageReady(img)) return;

      pending += 1;
      img.addEventListener('load', function () {
        pending -= 1;
        checkReady();
      }, { once: true });
      img.addEventListener('error', function () {
        pending -= 1;
        checkReady();
      }, { once: true });
      img.addEventListener('lazyloaded', checkReady, { once: true });

      if (window.lazySizes && img.classList.contains('lazyload') && !img.classList.contains('lazyloaded')) {
        window.lazySizes.loader.unveil(img);
      }
    }

    images.forEach(watchImage);
    checkReady();

    if (!card.dataset.pcLoaderTimeout) {
      card.dataset.pcLoaderTimeout = 'true';
      setTimeout(function () {
        card.dataset.pcLoaderDismissed = 'true';
        hideProductCardLoader(card);
      }, LOADER_TIMEOUT_MS);
    }
  }

  function altMatchesVariant(alt, variantId) {
    if (!variantId) return false;
    var id = String(variantId);
    var text = String(alt || '').toLowerCase().trim();
    if (!text) return false;
    if (text === id) return true;
    return text.split('-').indexOf(id) !== -1;
  }

  function parseGalleryData(galleriesRoot) {
    var node = galleriesRoot.querySelector('[data-pc-gallery-json]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function mediaForVariant(data, variantId) {
    if (!data || !data.m) return [];
    var matched = data.m.filter(function (item) {
      return altMatchesVariant(item.a, variantId);
    });
    return matched.length ? matched : null;
  }

  function buildSlide(item, multiplyMode) {
    var slide = document.createElement('div');
    slide.className = 'pc-gallery__slide';
    var img = document.createElement('img');
    img.src = item.u;
    img.alt = item.a || '';
    img.loading = 'lazy';
    img.width = 600;
    img.height = item.h || 600;
    img.className = 'pc-gallery__img' + (multiplyMode ? ' multiply-mode__target' : '');
    slide.appendChild(img);
    return slide;
  }

  function buildSlidesFromUrls(urls, multiplyMode) {
    return urls.map(function (url) {
      return buildSlide({ u: url, a: '', h: 600 }, multiplyMode);
    });
  }

  function buildDots(count) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pc-gallery__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('data-dot-index', String(i));
      dot.setAttribute('aria-label', 'Image ' + (i + 1));
      frag.appendChild(dot);
    }
    return frag;
  }

  function initGallery(gallery) {
    var track = gallery.querySelector('[data-pc-gallery-track]');
    var dotsWrap = gallery.querySelector('[data-pc-gallery-dots]');
    if (!track) return;

    var slides = function () {
      return Array.prototype.slice.call(track.querySelectorAll('.pc-gallery__slide'));
    };

    var dots = function () {
      if (!dotsWrap) return [];
      return Array.prototype.slice.call(dotsWrap.querySelectorAll('.pc-gallery__dot'));
    };

    var current = 0;
    gallery._pcDotPinned = false;
    gallery._pcHoverActive = false;

    function goTo(index) {
      var s = slides();
      if (!s.length) return;
      current = Math.max(0, Math.min(index, s.length - 1));
      track.style.transform = 'translateX(-' + current * 100 + '%)';
      dots().forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    if (dotsWrap && dotsWrap.dataset.pcDotsBound !== 'true') {
      dotsWrap.dataset.pcDotsBound = 'true';
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('.pc-gallery__dot');
        if (!dot) return;
        e.preventDefault();
        e.stopPropagation();
        var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
        if (isNaN(idx)) return;
        gallery._pcDotPinned = true;
        gallery._pcHoverActive = false;
        goTo(idx);
      });
    }

    gallery._pcGoTo = goTo;
    gallery._pcGoToHover = function (index) {
      if (gallery._pcDotPinned) return;
      goTo(index);
      gallery._pcHoverActive = true;
    };
    gallery._pcResetHover = function () {
      if (gallery._pcDotPinned || !gallery._pcHoverActive) return;
      goTo(0);
      gallery._pcHoverActive = false;
    };
    goTo(0);
  }

  function syncDots(gallery, slideCount) {
    var dotsWrap = gallery.querySelector('[data-pc-gallery-dots]');
    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';
    if (slideCount > 1) {
      dotsWrap.appendChild(buildDots(slideCount));
      dotsWrap.style.display = '';
    } else {
      dotsWrap.style.display = 'none';
    }
  }

  function bindGalleryLinks(card) {
    var url = card.getAttribute('data-url');
    if (!url) return;

    card.querySelectorAll('[data-pc-gallery]').forEach(function (gallery) {
      var viewport = gallery.querySelector('.pc-gallery__viewport');
      if (!viewport || viewport.dataset.pcLinkBound === 'true') return;
      viewport.dataset.pcLinkBound = 'true';
      viewport.classList.add('pc-gallery__viewport--linked');

      viewport.addEventListener('click', function (e) {
        if (e.target.closest('[data-pc-gallery-dots]')) return;
        window.location.href = url;
      });
    });
  }

  function populateGallery(gallery, slides, multiplyMode) {
    var track = gallery.querySelector('[data-pc-gallery-track]');
    if (!track) return;
    track.innerHTML = '';
    slides.forEach(function (slide, index) {
      slide.setAttribute('data-slide-index', String(index));
      track.appendChild(slide);
    });
    syncDots(gallery, slides.length);
    initGallery(gallery);
    bindGalleryHover(gallery);
  }

  function swapGalleryVariant(galleriesRoot, variantId) {
    if (!variantId) return;

    galleriesRoot.setAttribute('data-active-variant', variantId);

    var data = parseGalleryData(galleriesRoot);
    var multiplyMode = galleriesRoot.getAttribute('data-multiply-mode') === 'true';
    var variantMedia = mediaForVariant(data, variantId);

    var dualGallery = galleriesRoot.querySelector('[data-pc-gallery="dual"]');
    var fullGallery = galleriesRoot.querySelector('[data-pc-gallery="full"]');

    var dualItems = variantMedia ? variantMedia.slice(0, 2) : null;
    var fullItems = variantMedia;

    if (dualGallery) {
      var dualSlides;
      if (dualItems && dualItems.length) {
        dualSlides = dualItems.map(function (item) {
          return buildSlide(item, multiplyMode);
        });
      } else if (data && data.fb && data.fb.d) {
        dualSlides = buildSlidesFromUrls(data.fb.d, multiplyMode);
      } else {
        dualSlides = [];
      }
      populateGallery(dualGallery, dualSlides, multiplyMode);
    }

    if (fullGallery) {
      var fullSlides;
      if (fullItems && fullItems.length) {
        fullSlides = fullItems.map(function (item) {
          return buildSlide(item, multiplyMode);
        });
      } else if (data && data.fb && data.fb.f) {
        fullSlides = buildSlidesFromUrls(data.fb.f, multiplyMode);
      } else {
        fullSlides = [];
      }
      populateGallery(fullGallery, fullSlides, multiplyMode);
    }
  }

  function bindGalleryHover(gallery) {
    if (!gallery || gallery.dataset.pcHoverBound === 'true') return;
    gallery.dataset.pcHoverBound = 'true';

    gallery.addEventListener('mouseenter', function () {
      if (!DESKTOP_MQ.matches || !gallery._pcGoToHover) return;
      var slideCount = gallery.querySelectorAll('.pc-gallery__slide').length;
      if (slideCount > 1) gallery._pcGoToHover(1);
    });

    gallery.addEventListener('mouseleave', function () {
      if (!DESKTOP_MQ.matches || !gallery._pcResetHover) return;
      gallery._pcResetHover();
    });
  }

  function initCard(card) {
    if (!card || !card.classList.contains('product-card--with-extra-galleries')) return;

    dismissProductCardLoader(card);

    if (card.dataset.pcGalleriesInit === 'true') return;
    card.dataset.pcGalleriesInit = 'true';

    var galleriesRoot = card.querySelector('[data-product-card-galleries]');
    if (!galleriesRoot) return;

    galleriesRoot.querySelectorAll('[data-pc-gallery]').forEach(function (gallery) {
      var slideCount = gallery.querySelectorAll('.pc-gallery__slide').length;
      syncDots(gallery, slideCount);
      initGallery(gallery);
      bindGalleryHover(gallery);
    });

    bindGalleryLinks(card);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('product-card.product-card--with-extra-galleries').forEach(initCard);
  }

  function scheduleInitAll() {
    clearTimeout(initTimer);
    initTimer = setTimeout(function () {
      initAll();
    }, 50);
  }

  window.ProductCardGalleries = {
    init: initAll,
    initCard: initCard,
    swapVariant: function (card, variantId) {
      var galleriesRoot = card.querySelector('[data-product-card-galleries]');
      if (galleriesRoot) swapGalleryVariant(galleriesRoot, variantId);
      dismissProductCardLoader(card);
    },
    dismissLoader: dismissProductCardLoader
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('product-card.product-card--with-extra-galleries')) ||
            (node.querySelector && node.querySelector('product-card.product-card--with-extra-galleries'))
          ) {
            scheduleInitAll();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
